"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createSvgIcon = _interopRequireDefault(require("Functions/createSvgIcon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
let path = /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
  id: "Trac\xE9_2145",
  "data-name": "Trac\xE9 2145",
  d: "M3.8-.668a3.5,3.5,0,1,0-.088,6.986h.044A3.5,3.5,0,1,0,3.8-.668Zm0,0",
  transform: "translate(0 0.668)",
  fill: "#23bacf"
}), /*#__PURE__*/_react.default.createElement("path", {
  id: "Trac\xE9_2146",
  "data-name": "Trac\xE9 2146",
  d: "M8.109,198.313h6.72V218.53H8.109Zm0,0",
  transform: "translate(-7.712 -188.566)",
  fill: "#23bacf"
}), /*#__PURE__*/_react.default.createElement("path", {
  id: "Trac\xE9_2147",
  "data-name": "Trac\xE9 2147",
  d: "M233.992,188.625c-3.625,0-6.056,3.407-6.056,3.407V189.1h-6.72v20.218h6.72v-11.29a4.6,4.6,0,0,1,.221-1.64,3.679,3.679,0,0,1,3.448-2.457c2.432,0,3.4,1.854,3.4,4.572v10.816h6.72V197.725C241.728,191.515,238.413,188.625,233.992,188.625Zm0,0",
  transform: "translate(-210.379 -179.353)",
  fill: "#23bacf"
}));
let viewBox = '0 0 31.349 29.965';
var _default = exports.default = (0, _createSvgIcon.default)(path, 'LinkedinIcon', viewBox);
